import pluralize from "pluralize";

import {axios, getParams} from "@/src/modules/core/lib";
import type {ParamsOptions} from "@/src/modules/core/types";

interface ICoreApi {
  search: (path: string, options: ParamsOptions) => Promise<any>;
  getById: (path: string, id: string | number, options?: ParamsOptions) => Promise<any>;
  post: (path: string, data: any) => Promise<any>;
  get: (path: string, data?: any) => Promise<any>;
  create: (path: string, data: any) => Promise<any>;
  update: (path: string, id: string, data: any) => Promise<any>;
  delete: (path: string, id: string) => Promise<any>;
}

export default class CoreApi implements ICoreApi {
  post(path: string, data: any) {
    return axios({
      url: path,
      method: "post",
      data,
    });
  }

  get(path: string, data?: any) {
    return axios({
      url: path,
      method: "get",
      data,
    });
  }

  async search(path: string, options?: ParamsOptions) {
    const params = getParams(options);

    return axios({
      url: pluralize(path),
      method: "get",
      params,
    });
  }

  async getById(path: string, id: string | number, options?: ParamsOptions) {
    const params = getParams(options);

    return axios({
      url: `${path}/${id}`,
      method: "get",
      params,
    });
  }

  async create(
    path: string,
    data: any,
    options: {headers?: Record<string, string>; meta?: {feature?: string; operation?: string}} = {},
  ) {
    const {headers, meta, ...rest} = options;
    return axios({
      url: path,
      method: "post",
      data,
      headers,
      meta,
      ...rest,
    });
  }

  async update(
    path: string,
    id: string | number,
    data?: any,
    options: {meta?: {feature?: string; operation?: string}} = {},
  ) {
    const url = id ? `${path}/${id}` : path;
    return axios({
      url,
      method: "patch",
      data,
      meta: options.meta,
    });
  }

  async delete(path: string, id: string | number, data?: any) {
    return axios({
      url: `${path}/${id}`,
      method: "delete",
      data,
    });
  }
}
